<template>
  <form @submit.prevent="search(part)">
    <SfHeading :level="4" :title="$t('Search by Parts')" class="sf-heading--left" />
    <InputWithButton
      name="part"
      v-model="part"
      :placeholder="$t('Search by Parts')"
      :aria-label="$t('Search by Parts')"
      :button="{
        type: 'submit',
      }"
      >{{ $t("Submit") }}</InputWithButton
    >
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SfHeading } from '@storefront-ui/vue';
import { InputWithButton } from '@/modules/core';

export default {
  name: 'Level4Forms',
  components: {
    SfHeading,
    InputWithButton,
  },
  data() {
    return {
      part: '',
    };
  },
  computed: {
    ...mapGetters({
      vehicleData: 'level4/vehicleData',
    }),
  },
  methods: {
    search(part) {
      this.searchByParts({
        Sku: part,
        EquipmentList: [],
        VehicleKeyList: [],
      }).then(({ Interpretations, Boards, SimpleProduct }) => {
        this.$router.push({
          name: 'Level4Product',
          params: {
            product: SimpleProduct.Id,
            boards: Boards,
            interpretations: Interpretations,
          },
          query: {
            vehicleSpecific: true,
          },
        });
      });
    },
    ...mapActions({
      searchByParts: 'level4/searchByParts',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers";
@import "src/scss/_breakpoint";

.sf-heading {
  @include flexbox-desktop {
    margin-bottom: var(--spacer-sm);
  }
}

.sf-button--outline {
  --button-border-color: var(--_c-gray-secondary);
  --button-color: var(--_c-gray-secondary);
}
</style>
